import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef } from "react";

// The title every page opens with, in both the org and the study shell.
export const PageTitle = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"h1">) => (
  <h1
    className={cn(
      "text-listen-28 font-normal leading-tight text-content-primary",
      className
    )}
    {...props}
  />
);
PageTitle.displayName = "Page.Title";
